import React from 'react';

import { Box, Stack } from '@chakra-ui/react';

import { formatTooltip, renderTooltipFieldValue } from 'components/DataDisplay';

export const renderResourceNameIDTooltip = (name?: string, id?: string) => {
  return formatTooltip({
    header: 'RESOURCE',
    width: 64,
    content: (
      <Stack>
        <Box>{renderTooltipFieldValue('Name', name ?? '-')}</Box>
        <Box>{renderTooltipFieldValue('ID', id ?? '-')}</Box>
      </Stack>
    ),
  });
};
